import { render, staticRenderFns } from "./nearAccidentStatus.vue?vue&type=template&id=035f315f&scoped=true"
import script from "./nearAccidentStatus.vue?vue&type=script&lang=js"
export * from "./nearAccidentStatus.vue?vue&type=script&lang=js"
import style0 from "./nearAccidentStatus.vue?vue&type=style&index=0&id=035f315f&lang=sass"
import style1 from "./nearAccidentStatus.vue?vue&type=style&index=1&id=035f315f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f315f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035f315f')) {
      api.createRecord('035f315f', component.options)
    } else {
      api.reload('035f315f', component.options)
    }
    module.hot.accept("./nearAccidentStatus.vue?vue&type=template&id=035f315f&scoped=true", function () {
      api.rerender('035f315f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearAccidentStatus.vue"
export default component.exports